export const cardTypes = [
  { name: "Debit", value: "debit" },
  { name: "Credit", value: "credit" },
];

export const cardBrands = [
  { name: "Mastercard", value: "mastercard" },
  { name: "VISA", value: "visa" },
  { name: "Verve", value: "verve" },
];
